import { render, staticRenderFns } from "./registerCompany.vue?vue&type=template&id=7dc318db&scoped=true"
import script from "./registerCompany.vue?vue&type=script&lang=js"
export * from "./registerCompany.vue?vue&type=script&lang=js"
import style0 from "./registerCompany.vue?vue&type=style&index=0&id=7dc318db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc318db",
  null
  
)

export default component.exports